export default __webpack_public_path__ + "static/media/taking-notes.13e433ce.svg";